"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QiitaLogo = undefined;

var _hyperapp = require("hyperapp");

var _qiitaLogo = require("@increments/qiita-logo");

var QiitaLogo = exports.QiitaLogo = function QiitaLogo() {
  return (0, _hyperapp.h)(
    "svg",
    {
      "class": "slideMode-Dashboard_logo",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: _qiitaLogo.qiitaLogo.viewBox
    },
    (0, _hyperapp.h)(
      "title",
      null,
      "Qiita"
    ),
    (0, _hyperapp.h)("path", { d: _qiitaLogo.qiitaLogo.path })
  );
};